import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { LoadingIndicatorService } from '../../e-met/services/loading-indicator.service';

@Component({
    selector: 'app-global-loading-spinner',
    templateUrl: './global-loading-spinner.component.html',
    styleUrls: ['./global-loading-spinner.component.scss'],
})
export class GlobalLoadingSpinnerComponent implements OnInit {
    loadingStatusGlobal$ = this.service.loadingStatusGlobal$.pipe(
        map((status) => status.loading)
    );
    constructor(private service: LoadingIndicatorService) {}

    ngOnInit(): void {}
}
